// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"our-products_wrapper__SraLy"};